import { get as getCookie, set as setCookie } from "es-cookie";

const PANEL_SELECTOR_ID = "#ims-welcome-modal";
const COOKIE = "ims-welcome-modal-ctrl";

/**
 * Inicializa el componente, muestra el diálogo únicamente si no se ha hecho ya.
 */
export default function initialize(): void {
  const panel = $(PANEL_SELECTOR_ID);

  const show = getCookie(COOKIE);

  if (panel.length !== 0 && show !== "false") {
    panel.modal("show");
    setCookie(COOKIE, "false", { path: "/" });
  }
}
